import { EventEmitter } from 'events';

const paymentStatusEmitter = new EventEmitter();
const tutorialStepEmmiter = new EventEmitter();
const improvementsBadgeEmitter = new EventEmitter();

export { paymentStatusEmitter, tutorialStepEmmiter, improvementsBadgeEmitter };
